





import { Component, Vue, Watch } from "vue-property-decorator";
import EmployeeAttendDetails from "@/components/EmployeeAttendDetails.vue";
import { AppConstants } from "@/core/Export";
import store from "@/store";
@Component({
  components: { EmployeeAttendDetails }
})
export default class ManagerPersonalAreaPage extends Vue {
  constructor() {
    super();
  }

  created() {
    this.onSetScreenTitle();
    this.onSetCurrentEmployee();
  }

  onSetCurrentEmployee() {
    this.currentEmployee.id = this.appEnv.UserInfo.employeeId;
    this.currentEmployee.displayName = this.appEnv.UserInfo.displayName;
  }

  @Watch("selectedYear")
  @Watch("selectedMonth")
  onSetScreenTitle() {
    this.appEnv.screenTitle =
      this.$t("attend") +
      " " +
      this.$t("months." + this.selectedMonth.toString()) +
      " " +
      this.selectedYear;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  set currentEmployee(value) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, value);
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
